export const HotUpdater = {
  wrap: () => {
    return (WrappedComponent) => WrappedComponent
  },
  init: () => {},
  getBundleId: () => '00000000-0000-0000-0000-000000000000',
  getChannel: () => 'web',
  checkForUpdate: () => Promise.resolve(null),
  reload: () => Promise.resolve(),
}
